    function matchHeights() {

        const inners = document.querySelectorAll('.wp-block-slate-responsive-grid');
        const headings = document.querySelectorAll('.wp-block-slate-responsive-grid > div h3');
        
        // Reset heights to original values
        headings.forEach(heading => {
            heading.style.height = '';
        });
        
        inners.forEach(inner => {
            if (window.getComputedStyle(inner).clear === "both") {
                // Process headings in pairs
                for (let i = 0; i < headings.length; i += 2) {
                    const heading1 = headings[i];
                    const heading2 = headings[i + 1];
                    
                    if (!heading2) {
                        // If there's an odd number of headings, leave the last one alone
                        break;
                    }
                    
                    const height1 = heading1.offsetHeight;
                    const height2 = heading2.offsetHeight;
                    const maxHeight = Math.max(height1, height2);
                    
                    heading1.style.height = `${maxHeight}px`;
                    heading2.style.height = `${maxHeight}px`;
                }
            } else if (window.getComputedStyle(inner).clear === "left") {
                // Process headings in groups of three
                for (let i = 0; i < headings.length; i += 3) {
                    const heading1 = headings[i];
                    const heading2 = headings[i + 1];
                    const heading3 = headings[i + 2];
                    
                    if (!heading2 || !heading3) {
                        // If there are not enough headings to form a group of three, leave the remaining ones alone
                        break;
                    }
                    
                    const height1 = heading1.offsetHeight;
                    const height2 = heading2.offsetHeight;
                    const height3 = heading3.offsetHeight;
                    const maxHeight = Math.max(height1, height2, height3);
                    
                    heading1.style.height = `${maxHeight}px`;
                    heading2.style.height = `${maxHeight}px`;
                    heading3.style.height = `${maxHeight}px`;
                }
            } else if (window.getComputedStyle(inner).clear === "right") {
                // Process headings in groups of four
                for (let i = 0; i < headings.length; i += 4) {
                    const heading1 = headings[i];
                    const heading2 = headings[i + 1];
                    const heading3 = headings[i + 2];
                    const heading4 = headings[i + 3];
                    
                    if (!heading2 || !heading3 || !heading4) {
                        // If there are not enough headings to form a group of four, leave the remaining ones alone
                        break;
                    }
                    
                    const height1 = heading1.offsetHeight;
                    const height2 = heading2.offsetHeight;
                    const height3 = heading3.offsetHeight;
                    const height4 = heading4.offsetHeight;
                    const maxHeight = Math.max(height1, height2, height3, height4);
                    
                    heading1.style.height = `${maxHeight}px`;
                    heading2.style.height = `${maxHeight}px`;
                    heading3.style.height = `${maxHeight}px`;
                    heading4.style.height = `${maxHeight}px`;
                }
            }
        });

    }
    
    let resizeTimeout;
    
    function delayedMatchHeights() {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(matchHeights, 100);
    }
    
    // Run on page load
    matchHeights();
    
    // Run on window resize with 100ms delay
    window.addEventListener('resize', delayedMatchHeights);